const COLORS = {
  primary: '#0074A6',
  secondary: '#149EDA'
}
export default COLORS
